module.exports = __webpack_public_path__ + "static/media/en.7fb3f9b1.svg";